export var EStateType;
(function (EStateType) {
    EStateType["Loading"] = "LOADING";
    EStateType["Success"] = "SUCCESS";
    EStateType["Error"] = "ERROR";
})(EStateType || (EStateType = {}));
